"use strict";

var DateRangeFilter = require("./date-range-filter.jsx");
var ActivityStatusFilter = require("./activity-status-filter.jsx");
var UserSelectFilter = require("./user-select-filter.jsx");
var ActivityTypeFilter = require("./activity-type-filter.jsx");
var ViewTypeFilter = require("./view-type-filter.jsx");
var ActivitiesListingActions = require("app/screens/Activity/actions/activities-listing-actions");
var userPreferences = require("app/util/browser/user-preferences");
var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");
var moment = require("moment");
var _ = require("underscore");
moment.locale("pt-br");

var ActivitiesFilters = React.createClass({
  propTypes: {
    queryString: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object]),
    toggleActivityInput: React.PropTypes.func,
    totalActivitiesCount: React.PropTypes.number
  },
  componentWillMount: function() {
    if (_.isEmpty(this.props.queryString)) {
      this.filters = userPreferences.activityFilters.get();
    } else {
      this.filters = this.props.queryString;
    }
  },
  componentDidMount: function() {
    this.reloadActivities();
  },
  setFilter: function(filter, value, wait) {
    var repeated = false;
    this.filters["page"] = 1; // reset page because filter has changed
    if (this.filters[filter] === value) {
      repeated = true;
    }
    this.filters[filter] = value;
    userPreferences.activityFilters.set(this.filters);
    if (!wait && !repeated) {
      this.reloadActivities();
    }
  },
  reloadActivities: function() {
    ActivitiesListingActions.getActivities(this.filters);
  },
  render: function() {
    return (
      <div className="tasks-filter">
        <div className="task-header u-flex-center jc-sb p-20">
          <ActivityTypeFilter setFilter={this.setFilter} filters={this.filters} />
          <ActivityStatusFilter setFilter={this.setFilter} filters={this.filters} />
          <ViewTypeFilter />
        </div>
        <div className="u-flex-center jc-sb pt-20 pl-20 pr-20">
          <AddTaskButton onClick={this.props.toggleActivityInput}/>
          <DateRangeFilter setFilter={this.setFilter} filters={this.filters} />
          <UserSelectFilter setFilter={this.setFilter} filters={this.filters} totalActivitiesCount={this.props.totalActivitiesCount} />
        </div>
      </div>
    );
  }
});

var AddTaskButton = React.createClass({
  render: function () {
    return (
      <Button type="primary" onClick={this.props.onClick}>
        <span className="flex-center-all">
          <Icon custom={true} icon="task" className="c-primaryGreen"/>
          <span>Adicionar <span className="hidden-md hidden-sm hidden-xs">tarefa</span></span>
        </span>
      </Button>
    );
  }
});

module.exports = ActivitiesFilters;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityList/activities-filters.jsx